import { Select, SelectTrigger, SelectValue, SelectContent, SelectGroup, SelectItem } from '@/common/ui/select'
import { FC } from 'react'
import { cn } from '@/common/utils/utils'

export type View = 'Day' | 'Total'

type Props = {
    view: View
    setView: (view: View) => void
    inputClassName?: string
}

export const ViewSelector: FC<Props> = ({ view, setView, inputClassName }) => {
    return (
        <Select value={view} onValueChange={(value: View) => setView(value)}>
            <SelectTrigger
                id="view-selector"
                className={cn(
                    'w-52 rounded-full gap-2 border border-gray-300 py-2 px-4 !mt-0 focus:ring-transparent justify-end',
                    inputClassName,
                )}
            >
                <span className="mr-2 text-xs text-content-secondary">View by:</span>
                <SelectValue placeholder="Select view" />
            </SelectTrigger>
            <SelectContent>
                <SelectGroup>
                    <SelectItem value="Day">Day</SelectItem>
                    <SelectItem value="Total">Total</SelectItem>
                </SelectGroup>
            </SelectContent>
        </Select>
    )
}
